import { Alert, AlertType } from '@design/components/alert/Alert';
import { Button } from '@design/components/button/Button';
import { mailTo } from '@helpers';
import { ActionLink } from '@terminal/components/link/ActionLink';
import { config } from '@terminal/config';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import styles from './ErrorView.module.scss';

type ErrorViewProps = {
  handleClose: () => void;
  handleEdit: () => void;
};

export const ErrorView = ({ handleClose, handleEdit }: ErrorViewProps) => {
  const { t } = useTranslation(['screener', 'common']);
  const supportEmail = mailTo(config.supportEmail);

  return (
    <div className={styles.container} data-testid="scenario-assistant-error">
      <Alert
        className={styles.alert}
        type={AlertType.Error}
        variant="inline"
        title={t('screener:error.alfredErrorTitle')}
        message={
          <Trans
            t={t}
            i18nKey={'screener:error.alfredErrorDescription'}
            components={[<ActionLink key="key-0" href={supportEmail} />]}
            values={{
              email: config.supportEmail,
            }}
          />
        }
      />

      <footer className={styles.buttonContainer}>
        <Button
          variant="secondary"
          size="large"
          label={t('screener:editTextEntry')}
          onClick={handleEdit}
        />
        <Button
          variant="tertiary"
          size="large"
          label={t('common:cancel')}
          onClick={handleClose}
        />
      </footer>
    </div>
  );
};
